export const AUTORIDAD = [
  { id: "emergente", label: "Emergente", sub: "nuevo, construyendo", mult: 0.9 },
  { id: "establecido", label: "Establecido", sub: "reconocido, portafolio sólido", mult: 1.0 },
  { id: "autoridad", label: "Autoridad", sub: "referente, con marcas que te respaldan", mult: 1.2 },
];

export const PRODUCCION = [
  { id: "basico", label: "Básico", sub: "talking head, una toma", mult: 1.0 },
  { id: "intermedio", label: "Intermedio", sub: "varias tomas, edición", mult: 1.15 },
  { id: "alto", label: "Alto", sub: "producido, b-roll, gear, música", mult: 1.35 },
];

export const RELEVANCIA = [
  { id: "perfecto", label: "Perfecto", sub: "mismo nicho", mult: 1.4, tasaLead: 0.05 },
  { id: "adyacente", label: "Adyacente", sub: "relacionado", mult: 1.0, tasaLead: 0.025 },
  { id: "off", label: "Off-niche", sub: "fuera de lo tuyo", mult: 0.85, tasaLead: 0.01 },
];

export const INDUSTRIAS = [
  { id: "travel", label: "Travel", cpl: 4 },
  { id: "food", label: "Food", cpl: 5 },
  { id: "beauty", label: "Beauty", cpl: 6 },
  { id: "fashion", label: "Fashion", cpl: 8 },
  { id: "fitness", label: "Fitness", cpl: 8 },
  { id: "tech", label: "Tech / SaaS", cpl: 20 },
  { id: "salud", label: "Salud", cpl: 22 },
  { id: "seguros", label: "Seguros", cpl: 25 },
  { id: "finanzas", label: "Finanzas", cpl: 30 },
  { id: "otro", label: "Otra industria", cpl: null },
];

export function followerDollars(f) {
  return (
    (Math.min(f, 10000) / 1000) * 18 +
    (Math.max(0, Math.min(f, 50000) - 10000) / 1000) * 12 +
    (Math.max(0, Math.min(f, 150000) - 50000) / 1000) * 8 +
    (Math.max(0, f - 150000) / 1000) * 5
  );
}

export function computeTarifa({ seguidores, interacciones, autoridad, produccion, relevancia, cpl }) {
  const engagement = seguidores > 0 ? (interacciones / seguidores) * 100 : 0;
  const mult = 0.5 + engagement / 8;
  const followerVal = followerDollars(seguidores);
  const base = followerVal * mult;
  const bruto = base * autoridad * produccion * relevancia.mult;
  const tarifa = Math.max(150, bruto);
  const leads = seguidores * (engagement / 100) * relevancia.tasaLead;
  const leverage = leads * cpl;
  return {
    engagement,
    mult,
    followerVal,
    base,
    bruto,
    tarifa,
    leads,
    leverage,
    piso: bruto < 150,
  };
}

export const fmt$ = (n) => "$" + Math.round(n).toLocaleString("en-US");
export const fmtNum = (n) => Math.round(n).toLocaleString("en-US");
